import {
  FileInput,
  Highlighter,
  Eraser,
  AlertTriangle,
} from 'lucide-react';

/**
 * FormToolbar — Shown below the main toolbar when a PDF has form fields.
 * Provides highlight toggle, clear all, and save options.
 */
export default function FormToolbar({
  fieldCount,
  highlightFields,
  onToggleHighlight,
  onClearAll,
  requiredEmpty,
}) {

  return (
    <div className="flex items-center gap-3 h-12 sm:h-10 px-4 bg-brand-light border-b border-brand-muted/20 shrink-0 text-sm">
      <FileInput size={15} className="text-brand-blue" />
      <span className="text-brand-dark font-medium">
        {fieldCount} form field{fieldCount !== 1 ? 's' : ''}
      </span>

      <div className="h-4 w-px bg-brand-muted/30 mx-1" />

      {/* Highlight toggle */}
      <button
        onClick={onToggleHighlight}
        className={`flex items-center gap-1.5 px-2.5 py-2 sm:py-1 rounded-md transition-colors min-h-[44px] sm:min-h-0 ${
          highlightFields
            ? 'bg-brand-blue text-white'
            : 'text-brand-dark hover:bg-brand-light'
        }`}
      >
        <Highlighter size={13} />
        Highlight
      </button>

      {/* Clear all */}
      <button
        onClick={onClearAll}
        className="flex items-center gap-1.5 px-2.5 py-2 sm:py-1 rounded-md text-brand-dark hover:bg-brand-light transition-colors min-h-[44px] sm:min-h-0"
      >
        <Eraser size={13} />
        Clear All
      </button>

      <div className="flex-1" />

      {/* Required warning */}
      {requiredEmpty > 0 && (
        <span className="flex items-center gap-1 text-xs text-amber-700">
          <AlertTriangle size={12} />
          {requiredEmpty} required field{requiredEmpty !== 1 ? 's' : ''} empty
        </span>
      )}

    </div>
  );
}
